import {
  computed,
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import {
  ApplicationStore,
  MenuItemService,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import {
  AuthorizationStore,
  SOFTLINE_FEATURE_AUTHORIZATION,
} from '@softline/auth';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { default as en } from '../i18n/en.json';
import { SOFTLINE_PERMISSION_DASHBOARD } from './dashboard.shared';
import { DashboardGuard } from './guards/dashboard.guard';

export const dashboardProviders: Array<Provider | EnvironmentProviders> = [
  DashboardGuard,
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'dashboard',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'dashboard',
      language: 'en',
      translations: en,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#DASHBOARD.APP',
      icon: 'fa-regular fa-tachograph-digital',
      route: '/dashboard',
      permission: SOFTLINE_PERMISSION_DASHBOARD,
    });

    const menuItemService = inject(MenuItemService);
    menuItemService.add(
      computed(() => {
        const permissions = store.get(
          SOFTLINE_FEATURE_AUTHORIZATION,
          AuthorizationStore.getters.permissions
        );
        if (!permissions.includes(SOFTLINE_PERMISSION_DASHBOARD)) return [];
        return [
          {
            name: 'dashboardRoute',
            type: 'route' as const,
            outlet: 'nav-static',
            priority: 1,
            routerLink: ['/dashboard'],
            icon: 'fa-regular fa-tachograph-digital',
            title: '#DASHBOARD.APP',
          },
        ];
      })
    );
  }),
];
